import React from 'react';

export interface VasosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const VasosIcon: React.FC<VasosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <defs>
        <clipPath id="clippath">
          <path d="M.5.5h25v25H.5z" style={{ fill: 'none' }} />
        </clipPath>
        <style>{`.st1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}`}</style>
      </defs>
      <g style={{ clipPath: 'url(#clippath)' }}>
        <path d="M22.4 23.9h-6.5l-1-17.2h8.5zm-7.3-13.4h8.1" className="st1" />
        <path d="m18.1 21.7 1.5-18.2 4.5-.8m-14.5 12c-.1 1.5-1.4 2.7-3 2.7h0c-1.5 0-2.8-1.2-3-2.7l-.8-8.8h7.5l-.8 8.8Zm-.2 9.2H3.9l2.7-1.4 2.7 1.4Zm-2.7-6.4v4.9M3.2 9.3h6.9" className="st1" />
        <path d="M10.1 8.6c1.5 0 2.7-1.2 2.7-2.7s-1.2-2.7-2.7-2.7-2.7 1.2-2.7 2.7m-.8 9.3L4.4 2H1.9" className="st1" />
      </g>
    </svg>
  );
};

export default VasosIcon;
